import getTranslations from './getTranslations';

const actions = { getTranslations };

export default actions;
